const autoNgTemplateLoaderTemplate1 = require('./registry-form-proget.html');

angular.module('portainer.app').component('registryFormProget', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '=',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
  },
});
